import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

interface Payload {
  name: string,
  prompt?: string,
  objectId?: string,
  originalUrl: string,
  durationFrom: number,
  durationTo: number,
  duration: number,
  numClips: number,
}
const createVideo = async (payload: Payload): Promise<any> => {
  const res = await axiosInstance.post('/api/video-clipper/create', payload);
  return res.data;
};

export const useCreateAiClipperVideo = () => {
  return useMutation(createVideo, { onSuccess: (data) => data });
};
